import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { RowSelectEventArgs } from '@syncfusion/ej2-react-grids';
import { WorklistView } from '../../../../../../services/CaseManagementService';

/**
 * Hook for handling worklist row selection and navigation
 */
export function useWorklistNavigation(company: string, center: string) {
  const navigate = useNavigate();

  const handleRowSelected = useCallback(
    (args: RowSelectEventArgs) => {
      const selectedItem = args.data as WorklistView;
      if (selectedItem?.id) {
        navigate(
          `/case-management/case-edit?company=${encodeURIComponent(company)}&center=${encodeURIComponent(center)}&id=${encodeURIComponent(selectedItem.id)}`
        );
      }
    },
    [company, center, navigate]
  );

  return {
    handleRowSelected,
  };
}
